import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { notify } from 'libs/common';
import { ErrorMsg } from 'libs/form';
import { Popup2, Button, themes, ButtonContainer, SimpleInput } from 'libs/ui';
import { Content, NewTicketHeader, Line2 } from './penalty.styled';

export const Penalty = (props) => {
  const { id, close } = props;

  const { t } = useTranslation();

  /**
   * validate
   * @param {*} data
   * @returns
   */
  const validate = (data) => {
    let out = true;

    // Object.keys(data).forEach((key) => (out = data[key] !== ''));
    if (!data.comment) {
      out = false;
    }
    const amount = data.amount ? parseInt(data.amount) : 0;
    // console.log('amount', amount);
    if (amount <= 0) {
      out = false;
    }
    return out;
  };

  const [error, setError] = useState(false);
  const [working, setWorking] = useState(false);
  const [data, setData] = useState({ comment: 'Услуга', amount: '0' });
  const [validated, setValidated] = useState(validate(data));
  // console.log('validated', validated);

  /**
   * set value
   * @param {*} e
   */
  const setValue = (e) => {
    const out = { ...data };
    out[e.target.name] = e.target.value;
    const validated = validate(out);
    setData(out);
    setValidated(validated);
  };

  /**
   * save
   */
  const save = () => {
    setWorking(true);
    const out = {
      stay_id: id,
      comment: data.comment,
      amount: parseInt(data.amount) * 100,
    };
    api
      .call('stays.add_penalty', out)
      .then(() => {
        setWorking(false);

        close();
      })
      .catch((error) => {
        notify('Ошибка добавления услуги', error);
        setWorking(false);
      });
  };

  /**
   * filter number keys
   * @param {*} event 
   */
  const filterKeys = (event) => {
    if (['.', ',', '-', '+', 'e'].includes(event.key)) event.preventDefault();
  };

  return (
    <>
      <Popup2 w={366}>
        <Content>
          <NewTicketHeader>{t('buttons.Добавить услугу')}</NewTicketHeader>
          {error && <ErrorMsg error="Ошибка" />}

          <form>
            <Line2 className="fw">
              <span className="l">{t('grid.Название')}</span>
              <SimpleInput type="text" name="comment" value={data.comment} onChange={setValue} />
            </Line2>
            <Line2 className="fw">
              <span className="l">{t('form.Стоимость, Р')}</span>

              <SimpleInput type="number" name="amount" value={data.amount} onChange={setValue} min="1" step="1" onKeyDown={filterKeys} />
            </Line2>
          </form>
          <ButtonContainer space="20px" justifyContent={'flex-start'} style={{ marginTop: '40px' }}>
            <Button disabled={working} fontSize="16px" onClick={close}>
              Отменить
            </Button>
            <Button disabled={working || !validated} theme={themes.blue} fontSize="16px" onClick={save}>
              Начислить в долг
            </Button>
          </ButtonContainer>
        </Content>
      </Popup2>
    </>
  );
};
